const newPage = {
    path: 'newPage',
    component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftWeChat/found/newPage'], resolve)
  }
  
  export default newPage